module.exports = __webpack_public_path__ + "static/media/sticky-note.1d5cba48.jpg";